import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../../app/api.service';

@Component({
	selector: 'component-social',
	templateUrl: './social.html',
	styleUrls: ['./social.css']
})
export class ComponentSoical implements OnInit, AfterViewInit {

	@Input() submitAt : string = "" //顾问第一次回答的时间
	@Input() context : string ="" //追问
	@Input() myData : any //我的作答数据
	@Input() studentData : any //我的作答数据
	@Input() constituteId : number
	@Input() tabNum :number
	@Input() studentList : any
	@Input() relationId : number
	@Input() relationIdArr :any
    @Input() appreciateCount : number  //点赞次数
	@Input() userClick : boolean
	@Input() showCount : boolean
	@Input() comment : any;//评论内容
	@Input() commentCount : number; //评论次数
    @Input() commentList : any;
	@Output() onShowToast = new EventEmitter<any>();
	@Output() ongetStudentAppreciate = new EventEmitter<any>();
	@Output() ongetMyAppreciate = new EventEmitter<any>();
    isFavour : boolean  //用户自己是否点赞
	data : any = {};
	projectId : any;
	learningPathMetaId : any;
	constructor(
		private route: ActivatedRoute,
		private  apiService: ApiService,
		private router: Router,) {
		}
    ngOnInit() {
		let submitAt= null;
		submitAt = this.submitAt && typeof(this.submitAt) != "undefined" ? this.submitAt.split('.')[0].split('T') : "";
		this.submitAt = submitAt ? submitAt[0] + " " + submitAt[1] : "";

		let list =JSON.parse(JSON.stringify(this.commentList));
		list.map(item=>{
			let time = null; 
			if(item.studentCommentAt && typeof(item.studentCommentAt) != "undefined"){
				time = item.studentCommentAt.split('.')[0].split('T');
				item.studentCommentAt = time[0]+" " +time[1].split(":")[0]+":"+time[1].split(":")[1];
			}
			if(item.studentCommentByName.length > 10){
				item.studentCommentByName = item.studentCommentByName.slice(0,10)+"...";
			}
		})
		this.commentList = list;
		this.route.queryParams.subscribe(queryParams=>{
			this.learningPathMetaId = queryParams['learningPathMetaId'];
			this.projectId = queryParams['projectId'];
		})
	}

	ngAfterViewInit(){

	}
	//点赞
	favour(){
		if(this.tabNum == 0){
			this.data.relationId = this.myData.relationId;
			this.data.type = "appreciate";
			this.getAppreciate().then(result=>{
				if((!!result.some(item => item.userHomeworkRelationId === this.myData.relationId) === false)){
					this.giveAppreciate(this.data).then(result=>{
						this.ongetMyAppreciate.emit();
					})
				}else{
					this.onShowToast.emit(true);
				}
			})
		}else if(this.tabNum == 1){
			this.data.relationId = this.relationId;
			this.data.type = "appreciate";
			//判断是否已经点过赞
			this.getAppreciate().then(result=>{
				//没点过
				if((!!result.some(item => item.userHomeworkRelationId === this.relationId) === false)){
					this.giveAppreciate(this.data).then(result=>{
						this.ongetStudentAppreciate.emit({studentList:this.studentList,relationId:this.relationId});
					})
				}else{
					this.onShowToast.emit(true);
				}
			})
		}
    }
	//评论
	goComment(){
		if(this.projectId){
			this.router.navigate(['home-work-show-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,'projectId':this.projectId}});
		}else if(this.learningPathMetaId){
			this.router.navigate(['home-work-show-request'], { queryParams: { 'relationId': this.relationId,'constituteId': this.constituteId,'tabNum':this.tabNum,type:"comment",comment:this.comment,'learningPathMetaId':this.learningPathMetaId}});
		}
		
	}

	//点赞
    giveAppreciate(data) {
        return this.apiService.ajax({
            'type': 'post',
            'url': 'ddilearner/v2/user/project/homework/saveOperationLog',
            'data':data
        }).toPromise();
    }

	//点赞列表
	getAppreciate() {
        return this.apiService.ajax({
            'type': 'get',
            'url': 'ddilearner/v2/user/project/homework/getOperationLogList/3',
        }).toPromise();
    }
}



// WEBPACK FOOTER //
// ./src/app/app-home-work-show/home-work-social/social.ts